/**
 * Returs the client locale from browser, retuns en as fallback.
 */
import getDeviceLocale from "./getDeviceLocale";

export default () => {
  const locale = getDeviceLocale();

  // TODO: LocaleLoader must handle all language variations and not only the two first locale characters
  return locale && locale.length >= 2 ? locale.substring(0, 2) : "en";
};
